import React from 'react';
import styles from './windows-xp-splash.module.scss';
import { WindowIconSVG } from '../../common/constant/resume-data.constant';

interface WindowsXPSplashProps {}

const WindowsXPSplash: React.FC<WindowsXPSplashProps> = () => {
  return (
    <div className={styles.splash}>
      <div className={styles.centerContent}>
        <div className={styles.logoWrapper}>
          <div className={styles.windowsLogo}>
            <WindowIconSVG />
          </div>

          <h1 className={styles.title}>
            <span className={styles.microsoft}>Sunil Lohar</span>
            <br />
            Resume<span className={styles.xp}>XP</span>
          </h1>
        </div>

        <div className={styles.loaderWrapper}>
          <div className={styles.loaderTrack}>
            <div className={styles.loaderBar} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WindowsXPSplash;
